import React, { useState } from 'react';
import { get } from 'global/lib/lodash';
import { Icon, Select, MenuItem } from '@mui/material';
import { ButtonRowModal } from './styles';
import { Column, Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { Button } from 'global/components/Button';
import sendData from 'redux/actions/sendData';
import Modal from 'global/components/modal';
import SnackAlerts from 'global/components/snack-alerts';
import { useVendors, useClients } from 'global/hooks/useVendors';

export const TransferModal = (props) => {
  const { data, edId } = props;
  const [state, setState] = useState({
    selectedOption: '',
    step: 0,
  });
  const [alerts, setAlerts] = useState();

  const vendors = useVendors();
  const clients = useClients();

  const onClose = (updated = false) => {
    setState((s) => ({ ...s, step: 0, selectedOption: '' }));
    props.onClose && props.onClose(updated);
  };

  const submit = async () => {
    if (state.step === 0) {
      return setState((s) => ({ ...s, step: 1 }));
    }

    try {
      if (!state.selectedOption) {
        throw new Error('Please select option');
      }
      await sendData({
        url: `/editions/${edId}`,
        method: 'patch',
        data: {
          data: {
            id: edId,
            type: 'editions',
            attributes: {
              realm_id: state.selectedOption,
            },
          },
        },
      });
      onClose(true);
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    }
  };

  const all = [...clients.data.map((d) => ({ ...d, name: get(d, 'client.name'), type: 'client' })), ...vendors.data.map((d) => ({ ...d, name: get(d, 'vendor.name'), type: 'vendor' }))];

  return (
    <Modal {...props} onClose={onClose}>
      <Column fullWidth center>
        <Column style={{ width: '80%', paddingBottom: 40 }}>
          <Text type="label_medium">{`"${get(data, 'name')}" is currently owned by:`}</Text>
          <Text type="headline_large">{get(data, 'realm.name')}</Text>

          <Column fullWidth style={{ marginTop: 24, marginBottom: 24 }}>
            <Text>Transfer ownership to:</Text>
            {state.step === 1 ? (
              <Text bold type="headline_large">
                {get(
                  all.find((c) => get(c, `${c.type}Id`) == state.selectedOption),
                  'name'
                )}
              </Text>
            ) : (
              <Select displayEmpty onChange={(e) => setState((s) => ({ ...s, selectedOption: e.target.value }))} value={state.selectedOption} fullWidth>
                <MenuItem value="">
                  <em style={{ opacity: 0.5 }}>List of Clients/vendors</em>
                </MenuItem>
                {all.map((c) => (
                  <MenuItem value={`${get(c, `${c.type}Id`)}`}>{c.name}</MenuItem>
                ))}
              </Select>
            )}
          </Column>

          {state.step === 1 && (
            <Text type="label_medium" bold>
              Are you sure?
            </Text>
          )}
          <Text type="label_medium">
            This will permanently transfer the ownership of this Edition to another company. Once it's been changed, the only way to get it back is for that company to transfer it back. If you wish to
            merely share this Edition with another company, please use the “Admin Vendors” interface.
          </Text>
        </Column>

        <ButtonRowModal as={Row}>
          <Button disabled={!state.selectedOption} startIcon={<Icon>double_arrow</Icon>} onClick={() => submit()}>
            TRANSFER
          </Button>
        </ButtonRowModal>

        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
      </Column>
    </Modal>
  );
};
